import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import ConnUrls from '../../../../MyConns/Connections/ConnectURL';
import { HomePContext } from '../../../MyContexts/HomeP_Context';
import ImgAndTxtAndLnkCARD from '../../../MySections/DTechComps/ImgAndTxtAndLnkCARD';

const TabHPBottomSliders = (props) => {
    const [homeP, setHomeP] = useContext(HomePContext);

    const [mainTitle, setMainTitle] = useState(homeP.mainTitle);
    const [webSiteLogo, setWebSiteLogo] = useState(homeP.webSiteLogo);
    const [bottomImages, setBottomImagess] = useState(homeP.bottomImages);
    const [loginTopImages, setLoginTopImages] = useState(homeP.loginTopImages);
    const [bootomBaners, setBootomBaners] = useState(homeP.bootomBaners);

    const [mainGallDisp, setMainGallDisp] = useState();

    useEffect(() => {


    }, [])
    const setTheBottomImages = (urlsList) => {
        homeP["bottomImages"] = urlsList;
        setBottomImagess(urlsList);
    }



    return (
        <>
            <div className={"col-md-12 mb-2"}>

                 <div className={"col-md-12 mb-2"}>
                        <ImgAndTxtAndLnkCARD Head={"גלרייה תחתונה"} 
                        tblHeads={["מיקום", "תמונה", "תמונה מובייל", "טקסט על התמונה", "קישור", "מחק"]}
                            TheList={bottomImages} theFunction={(lst) => setTheBottomImages(lst)} eventKey={"elme_0"} />

                    </div>

            </div>

        </>

    );
}

export default TabHPBottomSliders;